import { HttpErrorResponse } from '@angular/common/http';

export function cleanError(err: any): Error {
  if (err instanceof Error) {
    return err;
  } else if (err instanceof HttpErrorResponse) {
    return new Error(err.message);
  } else if (typeof err === 'string') {
    return new Error(err);
  }
  return new Error('unknown error');
}